"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by cuppi on 2017/4/14.
 */
const JNetwork_1 = require("./JNetwork");
const JUrlList_1 = require("../unify/JUrlList");
const JDataUnify_1 = require("../unify/JDataUnify");
const NetworkDelegate_1 = require("../delegate/NetworkDelegate");
/**
 * 请求配置类
 * @memberOf module:network
 */
class JNetworkConfig {
    static setConfig(config) {
        JNetwork_1.default.baseUrl = config.baseUrl;
        JNetwork_1.default.delegate = Object.assign({}, NetworkDelegate_1.defaultInterceptor, config.delegate);
        JNetwork_1.default.carryData = config.carryData;
        JNetwork_1.default.axiosConfig = config.axiosConfig;
        let { urlMap, dataMap } = config;
        if (!urlMap || !dataMap) {
            console.log('Didn\'t find out the urlMap value or dataMap, do you forget it?');
        }
        else {
            JUrlList_1.UseConfig(urlMap);
            JDataUnify_1.UseConfig(dataMap);
        }
    }
}
exports.default = JNetworkConfig;
